import styled, { createGlobalStyle } from "styled-components";
import { Button, Collapse, DatePicker } from "antd";

const AGENCY_MODULE_CLASS = "affiliates-agency-module";
const AGENCY_PORTAL_CLASS = "affiliates-agency-portal";
const AGENCY_SELECT_DROPDOWN_CLASS = "affiliates-agency-select-dropdown";
const AGENCY_FONT_FAMILY = "Gilroy, sans-serif";

const agencyFontSelectors = `
  font-family: ${AGENCY_FONT_FAMILY};
  font-weight: 500;

  input,
  textarea,
  select,
  label,
  span,
  p,
  td,
  th,
  .ant-input,
  .ant-input-affix-wrapper,
  .ant-select,
  .ant-select-selection,
  .ant-select-selection__placeholder,
  .ant-select-selection-selected-value,
  .ant-form-item-label label,
  .ant-table-tbody > tr > td,
  .ant-pagination,
  .ant-pagination-item,
  .ant-drawer-body,
  .ant-modal-body,
  .ant-empty-description,
  .ant-spin-text,
  .ant-dropdown-menu-item,
  .ant-menu-item,
  .ant-upload-hint {
    font-family: ${AGENCY_FONT_FAMILY} !important;
    font-weight: 500 !important;
  }

  button,
  .ant-btn,
  .ant-table-thead > tr > th,
  .ant-table-column-title,
  .ant-collapse-header {
    font-family: ${AGENCY_FONT_FAMILY} !important;
    font-weight: 600 !important;
  }
`;

const AgencyModuleGlobalStyles = createGlobalStyle`
  .${AGENCY_MODULE_CLASS},
  .${AGENCY_PORTAL_CLASS} {
    ${agencyFontSelectors}
  }

  .${AGENCY_SELECT_DROPDOWN_CLASS},
  .${AGENCY_SELECT_DROPDOWN_CLASS} .ant-select-dropdown-menu-item {
    font-family: ${AGENCY_FONT_FAMILY} !important;
    font-weight: 500 !important;
  }
`;

const CHAZKI_LOGO_WHITE =
  "https://firebasestorage.googleapis.com/v0/b/chazki-link.appspot.com/o/nintendo%2FlogoBlanco.png?alt=media&token=14977f29-4eaa-4389-9433-832fcf7be99a";

const AgencyHeaderWrapper = styled.header`
  width: 100%;
  height: 80px;
  display: flex;
  flex-direction: row;
  background-color: white;
`;

const LogoChazkiStrip = styled.div`
  width: 264px;
  min-width: 264px;
  height: 80px;
  background: #307fe2;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    height: 24px;
  }

  @media only screen and (max-width: 600px) {
    width: 120px;
    min-width: 120px;
  }
`;

const AgencyHeaderContent = styled.div`
  flex: 1;
  height: 80px;
  padding: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: white;

  .namesUser {
    display: block;
    font-family: Gilroy, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    color: #595959;
    margin-right: 10px;
  }

  .cityCountryNames {
    font-family: Gilroy, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: #595959;
  }

  @media only screen and (max-width: 600px) {
    padding: 16px;

    .namesUser {
      display: none;
    }
  }
`;

const BtnDangerPrimary = styled(Button)`
  background: #cf1322;
  border: none;
  font-family: ${AGENCY_FONT_FAMILY};

  &:focus,
  &:hover,
  &:active {
    background: #cf1322;
    color: #ffffff;
  }
`;

const TitleDrawer = styled.div`
  font-family: Gilroy, sans-serif;

  & .title-drawer {
    font-weight: bold;
    font-size: 24px;
    line-height: 32px;
    margin-top: 25px;
    margin-bottom: 5px;
    color: #595959;
  }

  & .title-td-onerow {
    font-weight: bold;
    font-size: 22px;
    padding-bottom: 20px;
  }

  & .td-onerow {
    text-align: center;
    display: flex;
    align-items: center;
  }

  & .title-drawer-onerow {
    font-weight: bold;
    font-size: 18px;
    line-height: 32px;
    margin-top: 25px;
    margin-bottom: 5px;
    color: #595959;
  }

  & .descp-drawer {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #8c8c8c;
    margin-bottom: 25px;
  }

  & .avatar-drawer {
    margin-right: 15px;
  }
`;

const ContainerForm = styled.div`
  width: 100%;
  border-radius: 4px;
  font-family: ${AGENCY_FONT_FAMILY};
`;

const CustomCollapse = styled(Collapse)`
  box-shadow: none;
  background-color: white;
  font-family: ${AGENCY_FONT_FAMILY};

  & .ant-collapse-header {
    font-family: ${AGENCY_FONT_FAMILY};
    font-weight: bold;
    font-size: 15px;
  }
  & .ant-collapse-content {
    border-top: none;
  }
`;

const CustomDatePicker = styled(DatePicker)`
  width: 100%;
  font-family: ${AGENCY_FONT_FAMILY};

  & .ant-input {
    font-family: ${AGENCY_FONT_FAMILY};
    font-weight: 500;
    font-size: 14px;
  }
`;

const BlockSeparator = styled.div`
  height: 40px;
  background-color: white;
  width: 100%;
`;

const ContainerButtons = styled.div`
  position: fixed;
  right: 0px;
  bottom: 0px;
  width: 408px;
  height: 70px;
  padding: 10px;
  background-color: white;
  text-align: center;
  font-family: ${AGENCY_FONT_FAMILY};
`;

export {
  AGENCY_MODULE_CLASS,
  AGENCY_PORTAL_CLASS,
  AGENCY_SELECT_DROPDOWN_CLASS,
  AgencyModuleGlobalStyles,
  AgencyHeaderWrapper,
  LogoChazkiStrip,
  AgencyHeaderContent,
  CHAZKI_LOGO_WHITE,
  BtnDangerPrimary,
  TitleDrawer,
  ContainerForm,
  CustomCollapse,
  CustomDatePicker,
  BlockSeparator,
  ContainerButtons,
};
